import React, { useState, useRef, useEffect } from 'react'
import SearchComponent from './SearchComponent';
import ArtistFilterComponent from './ArtistFilterComponent';
import GenreFilterComponent from './GenreFilterComponent';
import MoodFilterComponent from './MoodFilterComponent';
import TagFilterComponent from './TagFilterComponent';
import FilterListComponent from './FilterListComponent';
import ComposerFilterComponent from './ComposerFilterComponent';
import filterIcon from '../icons/Search_button.svg'
import { useDispatch, useSelector } from 'react-redux';
import ResultsComponent from './ResultsComponent';
import { getSearchResults, executeFilter, getSearchResultsLength, getVideosFilterLength } from '../../actions/filterActions';
import { useSearchParams } from 'react-router-dom';

const NewSearchPage = (props) => {

    const [lastChangedComponent, setLastChangedComponent] = React.useState()

    const [searchValue, setSearchValue] = useState("")

    const [page, setPage] = useState(1)

    const [videoList, setVideoList] = React.useState([])

    const dispatch = useDispatch()

    const [funcId, setFuncId] = useState()

    const [searchParams, setSearchParams] = useSearchParams([])

    const albumId = parseInt(searchParams.get('album')) ? parseInt(searchParams.get('album')) : null

    const resultRef = useRef()

    const searchComponentId = 1
    const artistComponentId = 2
    const composerComponentId = 3
    const genreComponentId = 4
    const moodComponentId = 5
    const tagComponentId = 6
    const videoGenreComponentId = 8
    const albumComponentId = 9

    const {error, loading, filterResults, message, info, hasMore} = useSelector(state => state.filterResults)

    useEffect(()=>{
        if(albumId){
            props.setFilterList((prevArr)=>{ return[...prevArr, [albumId, "album", albumComponentId]]})
        }
    },[albumId])

    const filterGo = () => {
        setVideoList([])
        setPage(1)
        setFuncId(1)
        dispatch(executeFilter(props.filterList, 1, 1))
        dispatch(getVideosFilterLength(props.filterList))
    }

    const searchFun = (val) => {
        setVideoList([])
        setPage(1)
        setFuncId(2)
        dispatch(getSearchResults(val, 1, 1))
        dispatch(getSearchResultsLength(val))
    }

    useEffect(() => {
        const div = props.scrollRef.current;
        if (!div) return;

        const handleScroll = () => {

            if (loading) return;

            const scrollPosition = div.scrollTop + div.clientHeight;
            const fullHeight = div.scrollHeight;

            if (scrollPosition >= fullHeight - 300 && hasMore) {
            setPage(prev => prev + 1);
            }
        };

        div.addEventListener("scroll", handleScroll);
        return () => div.removeEventListener("scroll", handleScroll);

    }, [loading, hasMore, filterResults.length]);


    useEffect(() => {
        if (funcId === 1){
            dispatch(executeFilter(props.filterList, page+1, 1))
        } else if (funcId === 2){
            dispatch(getSearchResults(searchValue, page+1, 1))
        }
    }, [page]);


    return (
        <div className='w-100 p-2 p-md-5 bg-backcolor d-flex flex-column min-vh-100' >
            <div className = "col-12">
                <div className='col-12 d-flex flex-wrap flex-lg-nowrap gap-0'>
                    <div className = 'col-6 col-md-auto p-1'>
                        <div className = {
                            props.activeComponent === 1 ?
                            'w-100 text-center text-blueazur bg-info rounded fw-bold text-nowrap py-2 px-0 px-md-4' :
                            'w-100 text-center text-info bg-blueazur rounded fw-bold text-nowrap py-2 px-0 px-md-4'
                            }
                            onClick={()=>props.setActiveComponent(searchComponentId)}
                            role = "button"
                        >
                            Search By Title
                        </div>
                    </div>
                    <div className = 'col-6 col-md-auto p-1'>
                        <div className = {
                            props.activeComponent === 2 ?
                            'w-100 text-center text-blueazur bg-info rounded fw-bold text-nowrap py-2 px-0 px-md-4' :
                            'w-100 text-center text-info bg-blueazur rounded fw-bold text-nowrap py-2 px-0 px-md-4'
                        }
                            onClick={()=>props.setActiveComponent(artistComponentId)}
                            role = "button"
                        >
                            Artists
                        </div>
                    </div>
                    <div className = 'col-6 col-md-auto p-1'>
                        <div className = {
                            props.activeComponent === 3 ?
                            'w-100 text-center text-blueazur bg-info rounded fw-bold text-nowrap py-2 px-0 px-md-4' :
                            'w-100 text-center text-info bg-blueazur rounded fw-bold text-nowrap py-2 px-0 px-md-4'
                        }
                            onClick={()=>props.setActiveComponent(composerComponentId)}
                            role = "button"
                        >
                            Composers
                        </div>
                    </div>
                    <div className = 'col-6 col-md-auto p-1'>
                        <div className = {
                            props.activeComponent === 4 ?
                            'w-100 text-center text-blueazur bg-info rounded fw-bold text-nowrap py-2 px-0 px-md-4' :
                            'w-100 text-center text-info bg-blueazur rounded fw-bold text-nowrap py-2 px-0 px-md-4'
                        }
                            onClick={()=>props.setActiveComponent(genreComponentId)}
                            role = "button"
                        >
                            Genres
                        </div>
                    </div>
                    <div className = 'col-6 col-md-auto p-1'>
                        <div className = {
                            props.activeComponent === 5 ?
                            'w-100 text-center text-blueazur bg-info rounded fw-bold text-nowrap py-2 px-0 px-md-4' :
                            'w-100 text-center text-info bg-blueazur rounded fw-bold text-nowrap py-2 px-0 px-md-4'
                        }
                            onClick={()=>props.setActiveComponent(moodComponentId)}
                            role = "button"
                        >
                            Moods
                        </div>
                    </div>
                    <div className = 'col-6 col-md-auto p-1'>
                        <div className = {
                            props.activeComponent === 6 ?
                            'w-100 text-center text-blueazur bg-info rounded fw-bold text-nowrap py-2 px-0 px-md-4' :
                            'w-100 text-center text-info bg-blueazur rounded fw-bold text-nowrap py-2 px-0 px-md-4'
                        }
                            onClick={()=>props.setActiveComponent(tagComponentId)}
                            role = "button"
                        >
                            Tags
                        </div>
                    </div>
                </div>
                <div className='w-100 d-flex'>
                    {
                        props.activeComponent === searchComponentId &&
                        <SearchComponent
                            searchFun = {searchFun}
                            searchValue = {searchValue}
                            setSearchValue = {setSearchValue}
                        />
                    }
                    {
                        props.activeComponent === artistComponentId &&
                        <ArtistFilterComponent
                            filterList = {props.filterList}
                            setFilterList = {props.setFilterList}
                            lastChangedComponent = {lastChangedComponent}
                            setLastChangedComponent = {setLastChangedComponent}
                            componentId = {artistComponentId}
                        />
                    }
                    {
                        props.activeComponent === composerComponentId &&
                        <ComposerFilterComponent
                            filterList = {props.filterList}
                            setFilterList = {props.setFilterList}
                            lastChangedComponent = {lastChangedComponent}
                            setLastChangedComponent = {setLastChangedComponent}
                            componentId = {composerComponentId}
                        />
                    }
                    {
                        props.activeComponent === genreComponentId &&
                        <GenreFilterComponent
                            filterList = {props.filterList}
                            setFilterList = {props.setFilterList}
                            lastChangedComponent = {lastChangedComponent}
                            setLastChangedComponent = {setLastChangedComponent}
                            componentId = {genreComponentId}
                        />
                    }
                    {
                        props.activeComponent === moodComponentId &&
                        <MoodFilterComponent
                            filterList = {props.filterList}
                            setFilterList = {props.setFilterList}
                            lastChangedComponent = {lastChangedComponent}
                            setLastChangedComponent = {setLastChangedComponent}
                            componentId = {moodComponentId}
                        />
                    }
                    {
                        props.activeComponent === tagComponentId &&
                        <TagFilterComponent
                            filterList = {props.filterList}
                            setFilterList = {props.setFilterList}
                            lastChangedComponent = {lastChangedComponent}
                            setLastChangedComponent = {setLastChangedComponent}
                            componentId = {tagComponentId}
                        />
                    }
                    {
                        props.activeComponent !== searchComponentId && props.filterList.length ?
                        <div className='d-none d-md-block'>
                            <img
                                className='p-3'
                                src={filterIcon}
                                alt='filter'
                                role='button'
                                onClick={filterGo}
                            />
                        </div> : ""
                    }
                </div>
                {
                    props.activeComponent !== searchComponentId &&
                    <FilterListComponent
                        filterList = {props.filterList}
                        setFilterList = {props.setFilterList}
                        artistComponentId = {artistComponentId}
                        composerComponentId = {composerComponentId}
                        genreComponentId = {genreComponentId}
                        moodComponentId = {moodComponentId}
                        tagComponentId = {tagComponentId}
                        albumComponentId = {albumComponentId}
                    />
                }
                {
                    props.activeComponent !== searchComponentId && props.filterList.length ?
                    <div className='w-100 d-flex justify-content-end d-md-none'>
                        <img
                            className='p-3'
                            src={filterIcon}
                            alt='filter'
                            role='button'
                            onClick={filterGo}
                        />
                    </div> : ""
                }
            </div>
            {
                <div className='col-12 pt-4' >
                    <ResultsComponent
                        filterResults = {filterResults}
                        loading = {loading}
                        resultRef = {resultRef}
                        message = {message}
                        videoList = {videoList}
                        setVideoList = {setVideoList}
                        info = {info}
                    />
                </div>
            }
        </div>
    );
};

export default NewSearchPage;